import { TextEditor } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GiftMessageFooter } from './GiftMessageFooter';

function GiftMessageArea({ textAreaProps = {}, footerProps = {}, error }) {
  const { t } = useTranslation();
  const [isOpenCustomizeMessageModal, setOpenCustomizeMessageModal] = React.useState();

  return (
    <TextEditor
      {...(error && { status: 'error' })}
      key="gift-message-editor"
      required
      placeholder={t('giftMessage')}
      hasHelperText
      variant="outlined"
      styles={{
        toolbar: {
          zIndex: 3
        }
      }}
      {...textAreaProps}
    >
      {props => {
        return (
          <GiftMessageFooter
            error={error}
            isOpenCustomizeMessageModal={isOpenCustomizeMessageModal}
            setOpenCustomizeMessageModal={setOpenCustomizeMessageModal}
            {...footerProps}
            {...props}
          />
        );
      }}
    </TextEditor>
  );
}

export { GiftMessageArea };
